import React, { useState, useEffect, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import validate from 'validate.js'
import { makeStyles } from '@material-ui/styles'
import {
  Grid,
  Button,
  IconButton,
  TextField,
  Typography,
  InputAdornment
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate'

import { compose } from 'redux'
import { connect } from 'react-redux'
import { actionSaveBanner } from '../../store/actions/banner'

import { decodeFile, listStaticTypes } from '../../helpers'

const schema = {
  filename: {
    presence: { 
      allowEmpty: false, 
      message: 'Gambar harus diisi' 
    }
  },
  image: {
    presence: { 
      allowEmpty: false, 
      message: 'Gambar harus diisi'
    }
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  grid: {
    height: '100%'
  },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  textFile: {
    display: 'none'
  },
  iconFile: {
    cursor: 'pointer'
  },
  createButton: {
    margin: theme.spacing(2, 0)
  },
  imageContainer: {
    marginTop: theme.spacing(2),
    height: '100%',
    width: '60%',
    margin: '0 auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    width: '100%'
  }
}))

const BannerCreate = ({ history, saveBanner, dispatchSaveBanner }) => {
  const classes = useStyles()
  const [onState, setOnState] = useState(false)
  const fileRef = useRef(null)
  const [base64, setBase64] = useState('')

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      type: 'herbalkatalog'
    },
    touched: {},
    errors: {}
  })

  useEffect(() => {
    const errors = validate(formState.values, schema, { fullMessages: false })

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }))
  }, [formState.values])

  useEffect(() => {
    if(saveBanner.success && onState) {
      setOnState(false)
      history.goBack()
    }
  }, [saveBanner.success, onState, history])

  const handleChange = event => {
    event.persist()

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }))
  }

  const handleChangeFile = async (event) => {
    event.persist()
    const file = await decodeFile(event.target.files[0])
    
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        image: file.decode,
        filename: file.name
      },
      touched: {
        ...formState.touched,
        image: file.decode,
        filename: file.name
      }
    }))
    setBase64(file.base64)
  }

  const handleBack = () => {
    history.goBack()
  }

  const handleBannerCreate = event => {
    event.preventDefault()
    dispatchSaveBanner(formState.values)
    setOnState(true)
  }

  const handlePickFile = event => {
    fileRef.current.click()
  }

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false

  return (
    <div className={classes.root}>
      <Grid
        className={classes.grid}
        container
      >
        <Grid
          className={classes.content}
          item
          lg={12}
          xs={12}
        >
          <div className={classes.content}>
            <div className={classes.contentHeader}>
              <IconButton onClick={handleBack}>
                <ArrowBackIcon />
              </IconButton>
            </div>
            <div className={classes.contentBody}>
              <form
                className={classes.form}
                onSubmit={handleBannerCreate}
              >
                <Typography
                  className={classes.title}
                  variant="h2"
                >
                  Tambah Banner
                </Typography>
                <Typography
                  color="textSecondary"
                  gutterBottom
                >
                  Tautan banner boleh dikosongkan
                </Typography>
                <TextField
                  className={classes.textField}
                  error={hasError('url')}
                  fullWidth
                  helperText={
                    hasError('url') ? formState.errors.url[0] : null
                  }
                  label="Tautan Banner"
                  name="url"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.url || ''}
                  variant="outlined"
                />
                
                
                <TextField
                  className={classes.textField}
                  error={hasError('type')}
                  fullWidth
                  select
                  helperText={
                    hasError('type') ? formState.errors.type[0] : null
                  }
                  label="Tipe Banner"
                  name="type"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.type}
                  SelectProps={{ native: true }}
                  variant="outlined"
                >
                  {
                    listStaticTypes.banner.map((option) => (
                      <option
                        key={option.id}
                        value={option.id}
                      >
                        {option.name}
                      </option>
                    ))
                  }
                </TextField>
                <input 
                  accept="image/*" 
                  className={classes.textFile}
                  type="file"
                  ref={fileRef}
                  name="image"
                  onChange={handleChangeFile}
                />  
                <TextField
                  className={classes.textField}
                  error={hasError('filename')}
                  fullWidth
                  helperText={
                    hasError('filename') ? formState.errors.filename[0] : null
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment 
                        className={classes.iconFile} 
                        position="start"
                      >
                        <AddPhotoAlternateIcon />
                      </InputAdornment>
                    ),
                  }}
                  label="Gambar Banner"
                  placeholder="Pilih Gambar"
                  name="filename"
                  type="text"
                  onClick={handlePickFile}
                  value={formState.values.filename || ''}
                  variant="outlined"
                  disabled
                />
                {
                  (base64)
                  ? <div className={classes.imageContainer}>
                      <img 
                        className={classes.image}
                        alt="Gambar Banner"
                        src={base64}
                      />
                    </div>
                  : null
                }
                <Button
                  className={classes.createButton}
                  color="primary"
                  disabled={!formState.isValid}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Simpan
                </Button>
              </form>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

BannerCreate.propTypes = {
  history: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    saveBanner: {
      loading: state.banner.saveBanner.loading,
      success: state.banner.saveBanner.success
    }
  }
}

const mapDispatchToProps = (dispatch) => { 
  return {
    dispatchSaveBanner: (data) => dispatch(actionSaveBanner(data))
  }
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(BannerCreate)